<!-- Sidebar Toggle Button (Hamburger) - Only show when not pinned -->
<button *ngIf="!isPinned"
  class="sidebar-toggle fixed p-2.5 bg-white rounded-lg shadow-lg border border-gray-200 hover:bg-gray-50 transition-all"
  [style.top.px]="16" [style.left.px]="16" [style.z-index]="9999" (click)="toggleSidebar()" aria-label="Toggle menu">
  <i class="fas fa-bars text-gray-700 text-lg" *ngIf="!isOpen"></i>
  <i class="fas fa-times text-gray-700 text-lg" *ngIf="isOpen"></i>
</button>

<!-- Sidebar -->
<aside
  class="sidebar fixed top-0 left-0 h-full w-64 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col"
  [style.z-index]="999" [class.translate-x-0]="isOpen" [class.-translate-x-full]="!isOpen">

  <!-- Sidebar Header -->
  <div class="p-4 border-b border-gray-200 bg-gradient-to-r from-green-600 to-green-500">
    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <img src="images/logo.png" alt="ClearScrap" class="h-8" />
      </div>
      <button (click)="togglePin()" class="p-2 rounded-lg hover:bg-white hover:bg-opacity-20 transition-all"
        [title]="isPinned ? 'Unpin sidebar' : 'Pin sidebar'">
        <i class="fas text-white" [class.fa-thumbtack]="!isPinned" [class.fa-times]="isPinned"></i>
      </button>
    </div>
  </div>

  <!-- Sidebar Navigation -->
  <nav class="flex-1 overflow-y-auto p-4">

    <!-- ══════════════════════════════════════════════════════════════════════
         DASHBOARDS — Report_View / CCAdmin
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="[P.REPORT_VIEW, P.IS_CC_ADMIN]">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Dashboards</div>
      <a routerLink="/daily-glance"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-bolt mr-3 w-4 text-center"></i>
        <span>Today at a Glance</span>
      </a>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         APPOINTMENTS — CCAdmin + Telemarketer
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="[P.APPOINTMENTS_MANAGE, P.IS_TELEMARKETER]">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Appointments</div>
      <a routerLink="/appointments-list"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-list mr-3 w-4 text-center"></i>
        <span>All Appointments</span>
      </a>
      <a routerLink="/recurring-schedules"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-sync-alt mr-3 w-4 text-center"></i>
        <span>Recurring Schedules</span>
      </a>
      <a routerLink="/bulk-requests" routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-truck-loading mr-3 w-4 text-center"></i>
        <span>Bulk Inquiries</span>
      </a>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         SCRAP PRICING — CCAdmin + Telemarketer
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="[P.SCRAP_ITEM_MANAGE, P.IS_TELEMARKETER]">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Scrap Pricing</div>
      <a routerLink="/scrap-pricing"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-tags mr-3 w-4 text-center"></i>
        <span>Scrap Pricing</span>
      </a>
      <a routerLink="/scrap-categories"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-recycle mr-3 w-4 text-center"></i>
        <span>Scrap Categories</span>
      </a>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         MANAGEMENT
         ─ Customers     → CCAdmin + Telemarketer (Customer_Manage in composite)
         ─ Subscriptions → CCAdmin ONLY (Admin_Manage not in Telemarketer composite)
         ─ Holidays      → CCAdmin + Holiday_Manage
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="[P.CUSTOMER_MANAGE, P.HOLIDAY_MANAGE, P.HOLIDAY_LIST, P.IS_TELEMARKETER, P.IS_CC_ADMIN]">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Management</div>
      <!-- Customers: Telemarketer has Customer_Manage in their permission composite -->
      <a routerLink="/customers" routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold"
        (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-users mr-3 w-4 text-center"></i>
        <span>Customers</span>
      </a>
      <!-- Subscriptions: Telemarketer has Subscription_Manage in their composite -->
      <a routerLink="/subscriptions"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-credit-card mr-3 w-4 text-center"></i>
        <span>Subscriptions</span>
      </a>
      <!-- Holidays Calendar -->
      <a routerLink="/holidays"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1"
        *appHasPermission="[P.HOLIDAY_MANAGE, P.HOLIDAY_LIST, P.IS_CC_ADMIN]">
        <i class="fas fa-calendar-day mr-3 w-4 text-center"></i>
        <span>Holiday Calendar</span>
      </a>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         AGENTS — CCAdmin ONLY (Agent_Manage removed from Telemarketer composite)
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="P.IS_CC_ADMIN">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Agents</div>
      <a routerLink="/agents/leaderboard" routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold"
        (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-trophy mr-3 w-4 text-center text-amber-500"></i>
        <span class="font-medium">Agent Leaderboard</span>
      </a>
      <a routerLink="/agents" routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold"
        (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-user-tie mr-3 w-4 text-center"></i>
        <span>Manage Agents</span>
      </a>
      <a routerLink="/agents/leaves"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-calendar-minus mr-3 w-4 text-center"></i>
        <span>Agent Leaves</span>
      </a>
      <a routerLink="/agents/quotas"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-sliders-h mr-3 w-4 text-center"></i>
        <span>Agent Quotas</span>
      </a>
      <a routerLink="/agents/attendance"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-calendar-alt mr-3 w-4 text-center"></i>
        <span>Attendance Calendar</span>
      </a>

      <a routerLink="/agents/business-report"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-file-invoice-dollar mr-3 w-4 text-center"></i>
        <span>Agent Business Report</span>
      </a>
      <a routerLink="/agents/commissions"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-coins mr-3 w-4 text-center"></i>
        <span>Voucher Commissions</span>
      </a>
      <a routerLink="/agents/selfie-checkins"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-camera mr-3 w-4 text-center"></i>
        <span>Selfie Check-ins</span>
      </a>
      <a routerLink="/agents/invoices"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-file-invoice mr-3 w-4 text-center"></i>
        <span>Agent Invoices</span>
      </a>
      <a routerLink="/agents/transactions"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-receipt mr-3 w-4 text-center"></i>
        <span>Agent Transactions</span>
      </a>
      <a routerLink="/agents/ledgers"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-book mr-3 w-4 text-center"></i>
        <span>Agent Ledgers</span>
      </a>
      <a routerLink="/petty-cash"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-wallet mr-3 w-4 text-center"></i>
        <span>Petty Cash</span>
      </a>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         OPERATIONS & ANALYTICS — CCAdmin ONLY
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="P.IS_CC_ADMIN">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Operations &amp; Analytics</div>
      <a routerLink="/scrap-collections-list"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-box-open mr-3 w-4 text-center"></i>
        <span>Scrap Collections</span>
      </a>
      <a routerLink="/platform-charge-transactions"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-receipt mr-3 w-4 text-center"></i>
        <span>Platform Charges</span>
      </a>
      <a routerLink="/non-scrap-transactions"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-shopping-cart mr-3 w-4 text-center"></i>
        <span>Non Scrap Transactions</span>
      </a>
      <a routerLink="/scrap-collection-insights"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-chart-line mr-3 w-4 text-center"></i>
        <span>Collection Insights</span>
      </a>
      <a routerLink="/analytics" routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold"
        (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-chart-bar mr-3 w-4 text-center"></i>
        <span>Analytics Dashboard</span>
      </a>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         GEOGRAPHY — CCAdmin + Telemarketer + Marketer
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="[P.GEOZONE_MANAGE, P.DISTRICT_MANAGE, P.IS_TELEMARKETER, P.IS_MARKETER]">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Geography</div>
      <a routerLink="/geo-zones" routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold"
        (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-map-marked-alt mr-3 w-4 text-center"></i>
        <span>Geo Zones Manager</span>
      </a>
      <a routerLink="/districts" routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold"
        (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-map mr-3 w-4 text-center"></i>
        <span>Districts</span>
      </a>
      <a routerLink="/unsupported-geo-locations"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-map-marker-alt mr-3 w-4 text-center"></i>
        <span>Unsupported Locations Map</span>
      </a>
      <a routerLink="/unsupported-geo-locations/list"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-list-alt mr-3 w-4 text-center"></i>
        <span>Unsupported Locations List</span>
      </a>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         REPORTS — CCAdmin only
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="[P.REPORT_VIEW, P.IS_CC_ADMIN]">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Reports</div>
      <a routerLink="/reports/agent-insights"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-chart-line mr-3 w-4 text-center"></i>
        <span>Agent Insights</span>
      </a>
      <a routerLink="/reports/customer-collections"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-users mr-3 w-4 text-center"></i>
        <span>Customer Collections</span>
      </a>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         MARKETING — CCAdmin + Telemarketer + Marketer
         · Marketing Leads, Campaigns, Reports → all three roles (view)
         · Generate Leads   → Telemarketer + CCAdmin only (write)
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="[P.MARKETING_VIEW, P.IS_MARKETER, P.IS_TELEMARKETER]">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Marketing</div>
      <a routerLink="/marketing/leads"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-bullhorn mr-3 w-4 text-center"></i>
        <span>Marketing Leads</span>
      </a>
      <!-- Marketers have no Appointments section, so surface Bulk Inquiries (read-only) here -->
      <a routerLink="/bulk-requests" *ngIf="showBulkInquiriesInMarketing"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-truck-loading mr-3 w-4 text-center"></i>
        <span>Bulk Inquiries</span>
      </a>
      <a routerLink="/marketing/care-queue"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-headset mr-3 w-4 text-center"></i>
        <span>Care Queue</span>
      </a>
      <a routerLink="/marketing/campaigns"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-bullseye mr-3 w-4 text-center"></i>
        <span>Campaigns</span>
      </a>
      <a routerLink="/marketing/reports"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-chart-line mr-3 w-4 text-center"></i>
        <span>Reports</span>
      </a>
      <a routerLink="/marketing/acquisition"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-funnel-dollar mr-3 w-4 text-center"></i>
        <span>Acquisition</span>
      </a>
      <a routerLink="/marketing/whatsapp-send-log"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fab fa-whatsapp mr-3 w-4 text-center"></i>
        <span>WhatsApp Send Log</span>
      </a>
      <!-- Write action — Telemarketer + CCAdmin only -->
      <a routerLink="/marketing/place-collector"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1"
        *appHasPermission="[P.MARKETING_MANAGE, P.IS_TELEMARKETER]">
        <i class="fas fa-download mr-3 w-4 text-center"></i>
        <span>Generate Leads</span>
      </a>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         VOUCHERS — CCAdmin ONLY
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="P.IS_CC_ADMIN">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Vouchers</div>
      <a routerLink="/vouchers" routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold"
        (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-ticket-alt mr-3 w-4 text-center"></i>
        <span>Manage Vouchers</span>
      </a>
      <a routerLink="/voucher-configuration"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1"
        *appHasPermission="P.VOUCHER_CONFIG">
        <i class="fas fa-cog mr-3 w-4 text-center"></i>
        <span>Voucher Configuration</span>
      </a>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════════
         PARTNERS — not CCAdmin-only (invoice viewers may lack IS_CC_ADMIN)
         ══════════════════════════════════════════════════════════════════════ -->
    <div class="mb-4" *appHasPermission="[P.PARTNER_MANAGE, P.PARTNER_VIEW_INVOICES, P.IS_CC_ADMIN]">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">Partners</div>
      <a routerLink="/partners" routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold"
        (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1"
        *appHasPermission="P.PARTNER_MANAGE" [routerLinkActiveOptions]="{ exact: true }">
        <i class="fas fa-handshake mr-3 w-4 text-center"></i>
        <span>Partners</span>
      </a>
      <a routerLink="/partners/invoices"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1"
        *appHasPermission="[P.PARTNER_MANAGE, P.PARTNER_VIEW_INVOICES, P.IS_CC_ADMIN]">
        <i class="fas fa-file-invoice-dollar mr-3 w-4 text-center"></i>
        <span>Partner invoices</span>
      </a>
    </div>

    <!-- System Settings — CCAdmin ONLY -->
    <div class="mb-4" *appHasPermission="P.IS_CC_ADMIN">
      <div class="text-xs font-bold text-gray-500 uppercase tracking-wider mb-2 px-2">System Settings</div>
      <a routerLink="/settings"
        routerLinkActive="bg-green-50 text-green-600 border-l-4 border-green-600 font-semibold" (click)="closeSidebar()"
        class="flex items-center px-3 py-2.5 text-sm text-gray-700 hover:bg-green-50 hover:text-green-600 rounded-r-lg transition-all mb-1">
        <i class="fas fa-cogs mr-3 w-4 text-center"></i>
        <span>Global Settings</span>
      </a>
    </div>

  </nav>

  <!-- Sidebar Footer -->
  <div class="p-4 border-t border-gray-200 bg-gray-50">
    <div class="text-xs text-gray-500 text-center">
      <i class="fas fa-leaf text-green-600 mr-1"></i>
      ClearScrap Control Center
    </div>
  </div>
</aside>
